import React from 'react';
import video1 from '../../assets/img/tab/video-1.mp4';
import video2 from '../../assets/img/tab/video-2.mp4';
import video3 from '../../assets/img/tab/video-3.mp4';
import video4 from '../../assets/img/tab/video-4.mp4';
import './reels.css'; // Import CSS file for styles

const Reels = () => {
  return (
    <div id="reels-section">
      <div className="reels-container">
      <h2>Wedding Shoots</h2>
        <div className="video-row">
          <div className="video-wrapper">
            <video controls className="video" width="100%">
              <source src={video1} type="video/mp4" />
            </video>
          </div>
          <div className="video-wrapper">
            <video controls className="video" width="100%">
              <source src={video2} type="video/mp4" />
            </video>
          </div>
        </div>
        <div className="video-row">
          <div className="video-wrapper">
            <video controls className="video" width="100%">
              <source src={video3} type="video/mp4" />
            </video>
          </div>
          <div className="video-wrapper">
            <video controls className="video" width="100%">
              <source src={video4} type="video/mp4" />
            </video>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Reels;